import { t } from '@avalara/bat-apps-shared/i18n';
import { SBox, SDialog, SIcon } from '@avalara/skylab-sdk/react';

import type { SystemErrorOptions } from '@avalara/types/index';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { closeSystemErrorAndNavigate } from '../../lib/side-effects/system';
import { isEmbeddedSelector } from '../../selectors/offer';

type Props = {
  messaging: SystemErrorOptions;
};

const SimpleErrorMessage = ({ messaging }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isEmbedded = useSelector(isEmbeddedSelector);
  const errorTitle = messaging.title === 'SERV NOT ALLOWED' ? 'Invalid payment details' : messaging.title;

  useEffect(() => {
    const pageContent = document.querySelector<HTMLElement>('s-container[role="main"]');
    if (pageContent) pageContent.style.display = isEmbedded ? 'none' : '';
    return () => {
      if (pageContent) pageContent.style.display = '';
    };
  }, [isEmbedded]);

  return (
    <SBox>
      {!isEmbedded ? (
        <div className='pad-all-lg text-center'>
          <h2>{errorTitle}</h2>
          <p className='pad-top-sm pad-bottom-sm'>{messaging.message}</p>
          <button
            type='button'
            className='secondary icon-leading margin-top-md'
            onClick={() => dispatch(closeSystemErrorAndNavigate(history))}
          >
            <SIcon name='arrow-circle-left' />
            {t('client.buttons.go-back')}
          </button>
        </div>
      ) : (
        <SDialog open={true} aria-labelledby='dialog-title' aria-modal='true'>
          <div slot='header' id='dialog-title'>
            {errorTitle}
          </div>
          <div slot='body'>{messaging.message}</div>
          <div slot='footer'>
            <button type='button' className='secondary' onClick={() => dispatch(closeSystemErrorAndNavigate(history))}>
              {t('client.buttons.go-back-1')}
            </button>
          </div>
        </SDialog>
      )}
    </SBox>
  );
};

export default SimpleErrorMessage;
